module.exports = __webpack_public_path__ + "static/img/heart.2fd0fb2a.png";